import { put, takeLatest, all, call } from "redux-saga/effects";
import {
  fetchmyLabsList,
  myLabFeatures,
  updateRating,
  myLabsConnectApi,
  myLabExtsnVldtyGetApi,
  myLabExtsnVldtyUpdateApi,
  myLabVMAuthConnectApi,
  vmDetailsApi,
  myLabPooledVmDuration,
  addVmDurationApi,
  getLabInstructions,
  getInstanceSizeListApi,
  reconfigureVmApi,
  reprovisionLabApi,
  vmStateManageApi,
  manageVMExportApi,
  restoreVMApi,
} from "../api/myLabs";
import {
  myLabsListSuccess,
  myLabsListError,
  startMyLabSuccess,
  stopMyLabSuccess,
  suspendLabSuccess,
  deleteMyLabSuccess,
  resetLabSuccess,
  restartGuestSucess,
  shutdownGuestSuccess,
  myLabsLoaderSuccess,
  successUpdateRate,
  errorUpdateRate,
  myLabsConnectSuccess,
  myLabsConnectError,
  extensionValidityGetSuccess,
  extensionValidityGetError,
  extsnVldtyUpdateSuccess,
  extsnVldtyUpdateError,
  myLabVMAuthConnectDetailsSuccess,
  successVmDetails,
  errorVmDetails,
  getPooledVMTimerSuccess,
  getPooledVMTimerError,
  addVmDurationApiResponse,
  setAddVmDurationLoader,
  setLabInstructionsAction,
  forceDeleteMyLabSuccess,
  setInstanceSizeList,
  setInstanceSizeListLoader,
  setReconfigureVmLoader,
  setReconfigureVmSuccess,
  setReconfigureVmError,
  reprovisionLabError,
  reprovisionLabSuccess,
  vmStateManagementError,
  vmStateManagementLoading,
  vmStateManagementSuccess,
  manageVMExportLoading,
  manageVMExportError,
  manageVMExportSuccess,
  restoreVmError,
  restoreVmLoading,
  restoreVmSuccess,
} from "../actions";
import { myLabs } from "../../constants/actionTypes";
import {
  myLabsConstants,
  toasterFlags,
} from "../../constants/componentConstants";
import { statusCode } from "../../constants/apis/apiStatus";
import { toastNotification } from "../../utils/toast";
import { createVmApi } from "../api/userMachineCatalog";
import {
  createVmApiWorkspace,
  workspaceExtsnVldtyUpdateApi,
} from "../api/workspaceManager";

export function* fetchLabsListMainSaga({ payload }) {
  try {
    const labListdata = yield call(fetchmyLabsList, payload);
    if (labListdata?.status === statusCode.Ok200) {
      yield put(myLabsListSuccess(labListdata));
    } else {
      toastNotification(toasterFlags.ERROR, labListdata?.data);
      yield put(myLabsListError(labListdata?.data?.message));
      yield put(myLabsListSuccess(labListdata));
    }
  } catch (err) {
    yield put(myLabsListError(err));
  }
}

export function* mylabFeaturesMainSaga({
  urlParams,
  bodyData,
  operation,
  lab,
}) {
  try {
    yield put(myLabsLoaderSuccess(true));
    const operationLabData = yield call(myLabFeatures, urlParams, bodyData);
    if (operationLabData?.status === statusCode.Ok200) {
      if (operation === myLabsConstants.START) {
        yield put(startMyLabSuccess(operationLabData));
        yield put(myLabsLoaderSuccess(false));
      } else if (operation === myLabsConstants.STOP) {
        yield put(stopMyLabSuccess(operationLabData));
        yield put(myLabsLoaderSuccess(false));
      } else if (operation === myLabsConstants.SUSPEND) {
        yield put(suspendLabSuccess(operationLabData));
        yield put(myLabsLoaderSuccess(false));
      } else if (operation === myLabsConstants.DELETE) {
        yield put(deleteMyLabSuccess(operationLabData));
        yield put(myLabsLoaderSuccess(false));
        toastNotification(toasterFlags.SUCCESS, "VM deleted successfully");
      } else if (operation === myLabsConstants.RESET) {
        yield put(resetLabSuccess(operationLabData));
        yield put(myLabsLoaderSuccess(false));
      } else if (operation === myLabsConstants.RESTARTGUEST) {
        yield put(restartGuestSucess(operationLabData));
        yield put(myLabsLoaderSuccess(false));
      } else if (operation === myLabsConstants.SHUTDOWNGUEST) {
        yield put(shutdownGuestSuccess(operationLabData));
        yield put(myLabsLoaderSuccess(false));
      }
      if (operation === myLabsConstants.FORCEDELETE) {
        yield put(forceDeleteMyLabSuccess(operationLabData));
        yield put(myLabsLoaderSuccess(false));
      }
    } else {
      toastNotification(
        toasterFlags.ERROR,
        `${lab?.vm_name} : ${operationLabData?.data?.message}`
      );
      yield put(myLabsLoaderSuccess(false));
    }
  } catch (err) {
    yield put(myLabsLoaderSuccess(false));
  }
}

export function* updateRatingSagaFunction({ payload, id }) {
  try {
    const data = yield call(updateRating, payload, id);
    if (data?.status === statusCode.Ok200) {
      yield put(successUpdateRate(data));
      yield put(myLabsLoaderSuccess(false));
    } else {
      yield put(errorUpdateRate(data));
      toastNotification(toasterFlags.ERROR, data?.data?.message);
      yield put(myLabsLoaderSuccess(false));
    }
  } catch (err) {
    yield put(errorUpdateRate(err));
    yield put(myLabsLoaderSuccess(false));
  }
}

export function* myLabsConnectMainSaga({ id, payload }) {
  try {
    const connectdata = yield call(myLabsConnectApi, id, payload);
    if (connectdata?.status === statusCode.Ok200) {
      yield put(myLabsConnectSuccess(connectdata));
    } else {
      toastNotification(toasterFlags.ERROR, connectdata?.data);
    }
  } catch (err) {
    yield put(myLabsConnectError(err));
  }
}

export function* myLabsExtsnValidityMainSaga({ payload }) {
  try {
    const extVdtydata = yield call(myLabExtsnVldtyGetApi, payload);
    if (extVdtydata?.status === statusCode.Ok200) {
      yield put(extensionValidityGetSuccess(extVdtydata));
    } else {
      yield put(extensionValidityGetError(extVdtydata?.data?.message));
      yield put(myLabsLoaderSuccess(false));
    }
  } catch (err) {
    yield put(extensionValidityGetError(err));
    yield put(myLabsLoaderSuccess(false));
  }
}

export function* myLabsExtsnValidityUpdateMainSaga({ data }) {
  try {
    const extVdtyUpdatedata = yield call(myLabExtsnVldtyUpdateApi, data);
    if (extVdtyUpdatedata?.status === statusCode.Ok200) {
      yield put(extsnVldtyUpdateSuccess(extVdtyUpdatedata?.data?.Success));
    } else {
      if (extVdtyUpdatedata?.data.hasOwnProperty(myLabsConstants.Failure)) {
        yield put(extsnVldtyUpdateError(extVdtyUpdatedata?.data?.Failure));
      }
      yield put(myLabsLoaderSuccess(false));
    }
    if (extVdtyUpdatedata?.data?.error) {
      toastNotification(toasterFlags.ERROR, extVdtyUpdatedata?.data?.message);
    }
  } catch (err) {
    yield put(extsnVldtyUpdateError(err));
    yield put(myLabsLoaderSuccess(false));
  }
}

export function* workspaceExtsnValidityUpdateMainSaga({ data }) {
  try {
    const extVdtyUpdatedata = yield call(workspaceExtsnVldtyUpdateApi, data);
    if (extVdtyUpdatedata?.status === statusCode.Ok200) {
      yield put(extsnVldtyUpdateSuccess(extVdtyUpdatedata?.data?.Success));
    } else {
      if (extVdtyUpdatedata?.data.hasOwnProperty(myLabsConstants.Failure)) {
        yield put(extsnVldtyUpdateError(extVdtyUpdatedata?.data?.Failure));
      }
      yield put(myLabsLoaderSuccess(false));
      if (extVdtyUpdatedata?.status === statusCode.Ok200) {
        toastNotification(toasterFlags.ERROR, extVdtyUpdatedata?.data?.message);
      }
    }
  } catch (err) {
    yield put(extsnVldtyUpdateError(err));
    yield put(myLabsLoaderSuccess(false));
  }
}

export function* workspaceExtsnValidityCreateMainSaga({ data }) {
  try {
    const extVdtyUpdatedata = yield call(createVmApiWorkspace, data);
    if (extVdtyUpdatedata?.status === statusCode.Created201) {
      yield put(extsnVldtyUpdateSuccess(extVdtyUpdatedata?.data));
    } else {
      if (extVdtyUpdatedata?.data.hasOwnProperty(myLabsConstants.Failure)) {
        yield put(extsnVldtyUpdateError(extVdtyUpdatedata?.data?.Failure));
      }
      yield put(myLabsLoaderSuccess(false));
    }
  } catch (err) {
    yield put(extsnVldtyUpdateError(err));
    yield put(myLabsLoaderSuccess(false));
  }
}

export function* myLabsExtsnValidityCreateMainSaga({ data }) {
  try {
    const extVdtyUpdatedata = yield call(createVmApi, data);
    if (extVdtyUpdatedata?.status === statusCode.Created201) {
      yield put(extsnVldtyUpdateSuccess(extVdtyUpdatedata?.data));
    } else {
      if (extVdtyUpdatedata?.data.hasOwnProperty(myLabsConstants.Failure)) {
        yield put(extsnVldtyUpdateError(extVdtyUpdatedata?.data?.Failure));
      }
      yield put(myLabsLoaderSuccess(false));
    }
  } catch (err) {
    yield put(extsnVldtyUpdateError(err));
    yield put(myLabsLoaderSuccess(false));
  }
}

export function* myLabsVMAuthConnectMainSaga({ data }) {
  try {
    const vmAuthConnectdata = yield call(myLabVMAuthConnectApi, data);
    if (vmAuthConnectdata?.status === statusCode.Ok200) {
      yield put(myLabVMAuthConnectDetailsSuccess(vmAuthConnectdata?.data));
    } else {
      if (vmAuthConnectdata?.data?.error) {
        yield put(myLabsConnectError(vmAuthConnectdata));
      }
      toastNotification(toasterFlags.ERROR, vmAuthConnectdata?.data?.message);
      yield put(myLabsLoaderSuccess(false));
    }
  } catch (err) {
    yield put(myLabsConnectError(err));
    yield put(myLabsLoaderSuccess(false));
  }
}

export function* fetchVmDetailsFunction({ payload }) {
  try {
    const vmDetailsData = yield call(vmDetailsApi, payload);
    if (vmDetailsData?.status === statusCode.Ok200) {
      yield put(successVmDetails(vmDetailsData?.data));
    } else {
      toastNotification(toasterFlags.WARN, vmDetailsData?.data?.message);
      yield put(errorVmDetails(vmDetailsData?.data));
    }
  } catch (err) {
    yield put(errorVmDetails(err));
  }
}

export function* getPooledVmTimer({ payload }) {
  try {
    const vmDetailsData = yield call(myLabPooledVmDuration, payload);
    if (vmDetailsData?.status === statusCode.Ok200) {
      yield put(getPooledVMTimerSuccess(vmDetailsData?.data));
    } else {
      toastNotification(toasterFlags.WARN, vmDetailsData?.data?.message);
      yield put(getPooledVMTimerError(vmDetailsData?.data));
    }
  } catch (err) {
    yield put(getPooledVMTimerError(err));
  }
}

export function* addVmDurationFunction({ payload }) {
  try {
    const addDurationData = yield call(addVmDurationApi, payload);
    if (addDurationData?.status === statusCode.Ok200) {
      toastNotification(toasterFlags.SUCCESS, addDurationData?.data?.Success);
      yield put(
        addVmDurationApiResponse({
          data: addDurationData?.data?.Success,
          status: addDurationData?.status,
        })
      );
    } else {
      toastNotification(toasterFlags.WARN, addDurationData?.data?.message);
      yield put(
        addVmDurationApiResponse({
          data: addDurationData?.data,
          status: addDurationData?.status,
        })
      );
    }
    yield put(setAddVmDurationLoader(false));
  } catch (err) {
    yield put(setAddVmDurationLoader(false));
  }
}

export function* getLabInstructionsSaga({ payload }) {
  try {
    const vmDetailsData = yield call(getLabInstructions, payload);
    if (vmDetailsData?.status === statusCode.Ok200) {
      yield put(setLabInstructionsAction(vmDetailsData?.data));
    } else {
      toastNotification(toasterFlags.WARN, vmDetailsData?.data?.message);
      yield put(setLabInstructionsAction([]));
    }
  } catch (err) {
    yield put(setLabInstructionsAction([]));
  }
}

export function* getInstanceSizeListSaga({ payload }) {
  try {
    yield put(setInstanceSizeListLoader(true));
    const instanceSizeData = yield call(getInstanceSizeListApi, payload);
    yield put(setInstanceSizeListLoader(false));
    if (instanceSizeData?.status === statusCode.Ok200) {
      yield put(setInstanceSizeList(instanceSizeData?.data));
    } else {
      toastNotification(toasterFlags.WARN, instanceSizeData?.data?.message);
    }
  } catch (err) {
    yield put(setInstanceSizeListLoader(false));
    toastNotification(toasterFlags.WARN, err?.data?.message);
  }
}

export function* reConfigureVmSaga({ payload }) {
  try {
    yield put(setReconfigureVmLoader(true));
    const resData = yield call(reconfigureVmApi, payload);
    yield put(setReconfigureVmLoader(false));
    if (resData?.status === statusCode.Ok200) {
      toastNotification(toasterFlags.SUCCESS, resData?.data?.Success);
      yield put(setReconfigureVmSuccess(resData));
    } else {
      toastNotification(toasterFlags.WARN, resData?.data?.message);
      yield put(setReconfigureVmError(resData?.data));
    }
  } catch (err) {
    yield put(setReconfigureVmLoader(false));
    yield put(setReconfigureVmError(err));
  }
}

export function* reProvisionLabSaga({ payload }) {
  try {
    yield put(setReconfigureVmLoader(true));
    const resData = yield call(reprovisionLabApi, payload);
    yield put(setReconfigureVmLoader(false));
    if (resData?.status === statusCode.Ok200) {
      yield put(reprovisionLabSuccess(resData));
      toastNotification(toasterFlags.SUCCESS, resData?.data?.Success);
    } else {
      yield put(reprovisionLabError(resData?.data));
      toastNotification(toasterFlags.WARN, resData?.data?.message);
    }
  } catch (err) {
    yield put(reprovisionLabError(err));
    yield put(setReconfigureVmLoader(false));
  }
}

export function* vmStateManageSaga({ payload }) {
  try {
    yield put(vmStateManagementLoading(true));
    const data = yield call(vmStateManageApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(vmStateManagementSuccess(data?.data));
      toastNotification(
        toasterFlags.SUCCESS,
        data && (data?.data?.message || data?.data)
      );
    } else {
      toastNotification(
        toasterFlags.ERROR,
        data && (data?.data?.message || data?.data)
      );
      yield put(vmStateManagementError(data?.data));
    }
    yield put(vmStateManagementLoading(false));
  } catch (err) {
    yield put(vmStateManagementError(err));
  }
}

export function* manageVMExportSaga({ payload }) {
  try {
    yield put(manageVMExportLoading(true));
    const data = yield call(manageVMExportApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(manageVMExportSuccess(data?.data));
    } else {
      toastNotification(
        toasterFlags.ERROR,
        data && (data?.data?.message || data?.data)
      );
      yield put(manageVMExportError(data?.data));
    }
    yield put(manageVMExportLoading(false));
  } catch (err) {
    yield put(manageVMExportError(err));
  }
}

export function* restoreVmSaga({ payload }) {
  try {
    yield put(restoreVmLoading(true));
    const data = yield call(restoreVMApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(restoreVmSuccess(data?.data));
      toastNotification(
        toasterFlags.SUCCESS,
        data && (data?.data?.message || data?.data)
      );
    } else {
      toastNotification(
        toasterFlags.ERROR,
        data && (data?.data?.message || data?.data)
      );
      yield put(restoreVmError(data?.data));
    }
    yield put(restoreVmLoading(false));
  } catch (err) {
    yield put(restoreVmError(err));
  }
}

export function* MyLabsSaga() {
  yield takeLatest(myLabs.MY_LABS_LIST_REQUEST, fetchLabsListMainSaga);
  yield takeLatest(myLabs.MY_LAB_VM_OPERATION, mylabFeaturesMainSaga);
  yield takeLatest(myLabs.REQUEST_UPDATE_RATE, updateRatingSagaFunction);
  yield takeLatest(myLabs.CONNECT_GET_REQUEST, myLabsConnectMainSaga);
  yield takeLatest(
    myLabs.EXTENSION_VALIDITY_GET_REQUEST,
    myLabsExtsnValidityMainSaga
  );
  yield takeLatest(
    myLabs.EXTENSION_VALIDITY_UPDATE_REQUEST,
    myLabsExtsnValidityUpdateMainSaga
  );
  yield takeLatest(
    myLabs.EXTENSION_VALIDITY_UPDATE_REQUEST_WORKSPACE,
    workspaceExtsnValidityUpdateMainSaga
  );
  yield takeLatest(
    myLabs.EXTENSION_VALIDITY_CREATE_REQUEST,
    myLabsExtsnValidityCreateMainSaga
  );
  yield takeLatest(
    myLabs.EXTENSION_VALIDITY_CREATE_REQUEST_WORKSPACE,
    workspaceExtsnValidityCreateMainSaga
  );
  yield takeLatest(myLabs.VM_AUTH_CONNECT_DETAILS, myLabsVMAuthConnectMainSaga);
  yield takeLatest(myLabs.REQUEST_VM_DETAILS, fetchVmDetailsFunction);
  yield takeLatest(myLabs.GET_POOLED_VM_TIMER, getPooledVmTimer);
  yield takeLatest(myLabs.ADD_VM_DURATION, addVmDurationFunction);
  yield takeLatest(myLabs.GET_LAB_INSTRUCTIONS, getLabInstructionsSaga);
  yield takeLatest(myLabs.GET_INSTANCE_SIZE_LIST, getInstanceSizeListSaga);
  yield takeLatest(myLabs.RE_CONFIGURE_VM, reConfigureVmSaga);
  yield takeLatest(myLabs.RE_PROVISION_LAB_ACTION, reProvisionLabSaga);
  yield takeLatest(myLabs.VM_STATE_MANAGEMENT_ACTION, vmStateManageSaga);
  yield takeLatest(myLabs.MANAGE_VM_DOWNLOAD_ACTION, manageVMExportSaga);
  yield takeLatest(myLabs.RESTORE_VM_ACTION, restoreVmSaga);
}

export default function* dashboardSaga() {
  yield all([MyLabsSaga()]);
}
